export const useComponentId = (cqPath: string): string => {
  return cqPath.slice(cqPath.lastIndexOf("/") + 1, cqPath.length);
};

export default useComponentId;
